const FULFILLMENT_CHANGE_ITEM_ACTION = 'fulfillment-change-item'
const FULFILLMENT_CANCEL_ITEM_ACTION = 'fulfillment-cancel-item'
const FULFILLMENT_SPLIT_SHIPMENT_ACTION = 'fulfillment-split-shipment'

module.exports = {
  FULFILLMENT_CHANGE_ITEM_ACTION,
  FULFILLMENT_CANCEL_ITEM_ACTION,
  FULFILLMENT_SPLIT_SHIPMENT_ACTION,
}
